import $ from "jquery";
import _ from "lodash";
import AOS from "aos";
import "aos/dist/aos.css"; //
import "./forms/newsletter";
import "./insight";
import "./project";
import "./cookie";
import "slick-carousel";
import Rellax from "rellax";

window.$ = window.jQuery = $;

AOS.init();

// import 'bootstrap';
window.bootstrap = require("bootstrap/dist/js/bootstrap.bundle.js");

$(function () {
    let prevScrollpos = window.pageYOffset;

    function scrollCallback() {
        const $navbar = $("#main-header");
        const currentScrollPos = window.pageYOffset;
        if (currentScrollPos > 100) {
            if (prevScrollpos >= currentScrollPos) {
                $navbar.addClass("reveal");
            } else {
                $navbar.removeClass("reveal");
            }

            //default nav position
            $navbar.removeClass("top");
            $navbar.addClass("scroll-bottom");

        } else if (currentScrollPos <= 100) {
            setTimeout(function () {
                $navbar.removeClass("reveal");
            }, 50);

            //default nav position
            $navbar.addClass("top");
            $navbar.removeClass("scroll-bottom");
        } 
        prevScrollpos = currentScrollPos;
    }

    $(window).on("scroll", _.throttle(scrollCallback, 200, { leading: true }));
    $(".close-nav").on("click", function (e) {
        e.preventDefault();
        $(".body").removeClass("overflow-hidden");
        var myCollapse = document.getElementById("navbarNav");
        myCollapse.classList.remove("show");
    });
    $(".close-nav-menu").on("click", function (e) {
        $(".body").removeClass("overflow-hidden");
        $(".navbar").css("height", "98px");
        $(".navbar-brand").css("display", "inline-block");
        $("#navbar-front").css("display", "inline-block");
    });
    $(".navbar-toggler").on("click", function (e) {
        e.preventDefault();
        $(".body").addClass("overflow-hidden");
        $(".navbar").css("height", "100vh");
        $(".navbar-brand").css("display", "none");
        $("#navbar-front").css("display", "none");
    });
    $("#slide-carousel").slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 150,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 400,
                settings: {
                    slidesToShow: 2,
                },
            },
        ],
    });
    $(".action_filter").on("click", function (e) {
        $("#filter-mobile").addClass("show-filter");
        $("body").css("overflow", "hidden");
    });
    $(".close-filter").on("click", function (e) {
        $("#filter-mobile").removeClass("show-filter");
        $("body").css("overflow", "");
    });
    $(".btn-play_item").on("click", function (e) {
        $(".youtube-video")
            .get(0)
            .contentWindow.postMessage(
                '{"event":"command","func":"' + "playVideo" + '","args":""}',
                "*"
            );
        $(".btn-play").css("display", "none");
        $(".youtube-video").css("z-index", "2");
    });

    function checkInView(elem, partial) {
        var container = $("#sticky-container");
        var contHeight = container.height();
        var contTop = container.scrollTop();
        var contBottom = contTop + contHeight;

        var elemTop = $(elem).offset().top - container.offset().top;
        var elemBottom = elemTop + $(elem).height();

        var isTotal = elemTop >= 0 && elemBottom <= contHeight;
        var isPart =
            ((elemTop < 0 && elemBottom > 0) ||
                (elemTop > 0 && elemTop <= container.height())) &&
            partial;

        return isTotal || isPart;
    }
});

$(document).ready(function () {
    // get active menu sticky first row
    $(".menu-side-lett-mobile .menus .menus__item a").on("click", function () {
        $(".menu-side-lett-mobile .menus .menus__item a").removeClass("active");
    });

    // class active on scroll
    updateStickLink(0);
    $(window).scroll(function () {
        getStickyID();
        stickyScrollMobile();
        removeBackground();
    });

    function removeBackground() {
        var scrollHeight = $(document).height();
        var scrollPosition = $(window).height() + $(window).scrollTop();
        var scrollOnTop = $(window).scrollTop();

        if ($(".break").length) {
            if (scrollOnTop < 50) {
                $(".break").css('background', 'transparent');
                $(".break__content").addClass('d-none');
            } else if ((scrollHeight - scrollPosition) / scrollHeight === 0) {
                $(".break").css('background', 'transparent');
                $(".break__content").addClass('d-none');
            } else {
                $(".break__content").removeClass("d-none");
                $(".break").removeAttr("style");
            }
        }
    }

    function stickyScrollMobile() {
        var scrollTop = $(window).scrollTop(); // our current vertical position from the top

        if ($(".sticky-content").length > 0) {
            if (scrollTop > $(".sticky-content").offset().top) {
                $("#menu-project").addClass("d-block");
            } else {
                $("#menu-project").removeClass("d-block");
            }
        }
        if ($(".home-news__content-items").length > 0) {
            if (scrollTop > $(".home-news__content-items").offset().top) {
                $("#action_filter_mobile").addClass("d-block");
            } else {
                $("#action_filter_mobile").removeClass("d-block");
            }
        }
    }

    function getStickyID() {
        var scrollPosition = $(window).scrollTop();
        $(".sticky__scroll__item").each(function (index) {
            var data = $(this);
            var dataId = data.attr("data-id");
            var dataPoint = data[0].offsetTop;

            if (scrollPosition >= dataPoint) {
                updateStickLink(dataId);
            }
        });
    }

    function updateStickLink(dataId) {
        $(".menu-item").removeClass("active");
        $(".menu-item-" + dataId + "").addClass("active");
    }

    // Quote
    $(".slider-testimonial").slick({
        infinite: true,
        speed: 200,
        arrows: true,
        nextArrow:
            "<div class='arrow-next arrow'>  <svg viewBox='0 0 10 16' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M0.866666 15.0664C0.622222 14.822 0.5 14.5109 0.5 14.1331C0.5 13.7553 0.622222 13.4442 0.866666 13.1997L6.06667 7.99974L0.866666 2.79974C0.622222 2.5553 0.5 2.24418 0.5 1.86641C0.5 1.48863 0.622222 1.17752 0.866666 0.933072C1.11111 0.688628 1.42222 0.566406 1.8 0.566406C2.17778 0.566406 2.48889 0.688628 2.73333 0.933072L8.86667 7.06641C9 7.19974 9.09467 7.34418 9.15067 7.49974C9.20578 7.65529 9.23333 7.82196 9.23333 7.99974C9.23333 8.17752 9.20578 8.34418 9.15067 8.49974C9.09467 8.6553 9 8.79974 8.86667 8.93307L2.73333 15.0664C2.48889 15.3109 2.17778 15.4331 1.8 15.4331C1.42222 15.4331 1.11111 15.3109 0.866666 15.0664Z' fill='currentColor'/></svg></div>",
        prevArrow:
            "<div class='arrow-prev arrow'>  <svg viewBox='0 0 10 16' fill='none' xmlns='http://www.w3.org/2000/svg'> <path d='M0.866666 15.0664C0.622222 14.822 0.5 14.5109 0.5 14.1331C0.5 13.7553 0.622222 13.4442 0.866666 13.1997L6.06667 7.99974L0.866666 2.79974C0.622222 2.5553 0.5 2.24418 0.5 1.86641C0.5 1.48863 0.622222 1.17752 0.866666 0.933072C1.11111 0.688628 1.42222 0.566406 1.8 0.566406C2.17778 0.566406 2.48889 0.688628 2.73333 0.933072L8.86667 7.06641C9 7.19974 9.09467 7.34418 9.15067 7.49974C9.20578 7.65529 9.23333 7.82196 9.23333 7.99974C9.23333 8.17752 9.20578 8.34418 9.15067 8.49974C9.09467 8.6553 9 8.79974 8.86667 8.93307L2.73333 15.0664C2.48889 15.3109 2.17778 15.4331 1.8 15.4331C1.42222 15.4331 1.11111 15.3109 0.866666 15.0664Z' fill='currentColor'/></svg></div>",
    });

    var rellaxImage;
    var rellax;

    if(window.matchMedia("(max-width: 992px)").matches){
        // The viewport is less than 768 pixels wide
        if ($('.rellax').length) {
            rellax.destroy();
        }
        if($('#paralax-container').length) {
            rellaxImage.destroy();
        }
    } else{
        rellax = new Rellax(".rellax", {
            speed: 3,
            center: true,
            vertical: true,
            horizontal: false,
        });

        // Image Paralax 
        rellaxImage = new Rellax("#paralax-container", {
            speed: 6,
            center: true,
            vertical: true,
            horizontal: false,
        })
    }
});
